var defaultStyles = {
  "col": "Base-Rid-Col.module--Col",
  "col_variant_spaced": "Base-Rid-Col.module--ColVariantSpaced",
  "col_span_0": "Base-Rid-Col.module--ColSpan_0",
  "col_xs_span_0": "Base-Rid-Col.module--ColXsSpan_0",
  "col_span_1": "Base-Rid-Col.module--ColSpan_1",
  "col_xs_span_1": "Base-Rid-Col.module--ColXsSpan_1",
  "col_span_2": "Base-Rid-Col.module--ColSpan_2",
  "col_xs_span_2": "Base-Rid-Col.module--ColXsSpan_2",
  "col_span_3": "Base-Rid-Col.module--ColSpan_3",
  "col_xs_span_3": "Base-Rid-Col.module--ColXsSpan_3",
  "col_span_4": "Base-Rid-Col.module--ColSpan_4",
  "col_xs_span_4": "Base-Rid-Col.module--ColXsSpan_4",
  "col_span_5": "Base-Rid-Col.module--ColSpan_5",
  "col_xs_span_5": "Base-Rid-Col.module--ColXsSpan_5",
  "col_span_6": "Base-Rid-Col.module--ColSpan_6",
  "col_xs_span_6": "Base-Rid-Col.module--ColXsSpan_6",
  "col_span_7": "Base-Rid-Col.module--ColSpan_7",
  "col_xs_span_7": "Base-Rid-Col.module--ColXsSpan_7",
  "col_span_8": "Base-Rid-Col.module--ColSpan_8",
  "col_xs_span_8": "Base-Rid-Col.module--ColXsSpan_8",
  "col_span_9": "Base-Rid-Col.module--ColSpan_9",
  "col_xs_span_9": "Base-Rid-Col.module--ColXsSpan_9",
  "col_span_10": "Base-Rid-Col.module--ColSpan_10",
  "col_xs_span_10": "Base-Rid-Col.module--ColXsSpan_10",
  "col_span_11": "Base-Rid-Col.module--ColSpan_11",
  "col_xs_span_11": "Base-Rid-Col.module--ColXsSpan_11",
  "col_span_12": "Base-Rid-Col.module--ColSpan_12",
  "col_xs_span_12": "Base-Rid-Col.module--ColXsSpan_12",
  "col_offset_0": "Base-Rid-Col.module--ColOffset_0",
  "col_xs_offset_0": "Base-Rid-Col.module--ColXsOffset_0",
  "col_offset_1": "Base-Rid-Col.module--ColOffset_1",
  "col_xs_offset_1": "Base-Rid-Col.module--ColXsOffset_1",
  "col_offset_2": "Base-Rid-Col.module--ColOffset_2",
  "col_xs_offset_2": "Base-Rid-Col.module--ColXsOffset_2",
  "col_offset_3": "Base-Rid-Col.module--ColOffset_3",
  "col_xs_offset_3": "Base-Rid-Col.module--ColXsOffset_3",
  "col_offset_4": "Base-Rid-Col.module--ColOffset_4",
  "col_xs_offset_4": "Base-Rid-Col.module--ColXsOffset_4",
  "col_offset_5": "Base-Rid-Col.module--ColOffset_5",
  "col_xs_offset_5": "Base-Rid-Col.module--ColXsOffset_5",
  "col_offset_6": "Base-Rid-Col.module--ColOffset_6",
  "col_xs_offset_6": "Base-Rid-Col.module--ColXsOffset_6",
  "col_offset_7": "Base-Rid-Col.module--ColOffset_7",
  "col_xs_offset_7": "Base-Rid-Col.module--ColXsOffset_7",
  "col_offset_8": "Base-Rid-Col.module--ColOffset_8",
  "col_xs_offset_8": "Base-Rid-Col.module--ColXsOffset_8",
  "col_offset_9": "Base-Rid-Col.module--ColOffset_9",
  "col_xs_offset_9": "Base-Rid-Col.module--ColXsOffset_9",
  "col_offset_10": "Base-Rid-Col.module--ColOffset_10",
  "col_xs_offset_10": "Base-Rid-Col.module--ColXsOffset_10",
  "col_offset_11": "Base-Rid-Col.module--ColOffset_11",
  "col_xs_offset_11": "Base-Rid-Col.module--ColXsOffset_11",
  "col_order_0": "Base-Rid-Col.module--ColOrder_0",
  "col_xs_order_0": "Base-Rid-Col.module--ColXsOrder_0",
  "col_order_1": "Base-Rid-Col.module--ColOrder_1",
  "col_xs_order_1": "Base-Rid-Col.module--ColXsOrder_1",
  "col_order_2": "Base-Rid-Col.module--ColOrder_2",
  "col_xs_order_2": "Base-Rid-Col.module--ColXsOrder_2",
  "col_order_3": "Base-Rid-Col.module--ColOrder_3",
  "col_xs_order_3": "Base-Rid-Col.module--ColXsOrder_3",
  "col_order_4": "Base-Rid-Col.module--ColOrder_4",
  "col_xs_order_4": "Base-Rid-Col.module--ColXsOrder_4",
  "col_order_5": "Base-Rid-Col.module--ColOrder_5",
  "col_xs_order_5": "Base-Rid-Col.module--ColXsOrder_5",
  "col_order_6": "Base-Rid-Col.module--ColOrder_6",
  "col_xs_order_6": "Base-Rid-Col.module--ColXsOrder_6",
  "col_order_7": "Base-Rid-Col.module--ColOrder_7",
  "col_xs_order_7": "Base-Rid-Col.module--ColXsOrder_7",
  "col_order_8": "Base-Rid-Col.module--ColOrder_8",
  "col_xs_order_8": "Base-Rid-Col.module--ColXsOrder_8",
  "col_order_9": "Base-Rid-Col.module--ColOrder_9",
  "col_xs_order_9": "Base-Rid-Col.module--ColXsOrder_9",
  "col_order_10": "Base-Rid-Col.module--ColOrder_10",
  "col_xs_order_10": "Base-Rid-Col.module--ColXsOrder_10",
  "col_order_11": "Base-Rid-Col.module--ColOrder_11",
  "col_xs_order_11": "Base-Rid-Col.module--ColXsOrder_11",
  "col_order_12": "Base-Rid-Col.module--ColOrder_12",
  "col_xs_order_12": "Base-Rid-Col.module--ColXsOrder_12",
  "col_pull_0": "Base-Rid-Col.module--ColPull_0",
  "col_xs_pull_0": "Base-Rid-Col.module--ColXsPull_0",
  "col_pull_1": "Base-Rid-Col.module--ColPull_1",
  "col_xs_pull_1": "Base-Rid-Col.module--ColXsPull_1",
  "col_pull_2": "Base-Rid-Col.module--ColPull_2",
  "col_xs_pull_2": "Base-Rid-Col.module--ColXsPull_2",
  "col_pull_3": "Base-Rid-Col.module--ColPull_3",
  "col_xs_pull_3": "Base-Rid-Col.module--ColXsPull_3",
  "col_pull_4": "Base-Rid-Col.module--ColPull_4",
  "col_xs_pull_4": "Base-Rid-Col.module--ColXsPull_4",
  "col_pull_5": "Base-Rid-Col.module--ColPull_5",
  "col_xs_pull_5": "Base-Rid-Col.module--ColXsPull_5",
  "col_pull_6": "Base-Rid-Col.module--ColPull_6",
  "col_xs_pull_6": "Base-Rid-Col.module--ColXsPull_6",
  "col_pull_7": "Base-Rid-Col.module--ColPull_7",
  "col_xs_pull_7": "Base-Rid-Col.module--ColXsPull_7",
  "col_pull_8": "Base-Rid-Col.module--ColPull_8",
  "col_xs_pull_8": "Base-Rid-Col.module--ColXsPull_8",
  "col_pull_9": "Base-Rid-Col.module--ColPull_9",
  "col_xs_pull_9": "Base-Rid-Col.module--ColXsPull_9",
  "col_pull_10": "Base-Rid-Col.module--ColPull_10",
  "col_xs_pull_10": "Base-Rid-Col.module--ColXsPull_10",
  "col_pull_11": "Base-Rid-Col.module--ColPull_11",
  "col_xs_pull_11": "Base-Rid-Col.module--ColXsPull_11",
  "col_pull_12": "Base-Rid-Col.module--ColPull_12",
  "col_xs_pull_12": "Base-Rid-Col.module--ColXsPull_12",
  "col_push_0": "Base-Rid-Col.module--ColPush_0",
  "col_xs_push_0": "Base-Rid-Col.module--ColXsPush_0",
  "col_push_1": "Base-Rid-Col.module--ColPush_1",
  "col_xs_push_1": "Base-Rid-Col.module--ColXsPush_1",
  "col_push_2": "Base-Rid-Col.module--ColPush_2",
  "col_xs_push_2": "Base-Rid-Col.module--ColXsPush_2",
  "col_push_3": "Base-Rid-Col.module--ColPush_3",
  "col_xs_push_3": "Base-Rid-Col.module--ColXsPush_3",
  "col_push_4": "Base-Rid-Col.module--ColPush_4",
  "col_xs_push_4": "Base-Rid-Col.module--ColXsPush_4",
  "col_push_5": "Base-Rid-Col.module--ColPush_5",
  "col_xs_push_5": "Base-Rid-Col.module--ColXsPush_5",
  "col_push_6": "Base-Rid-Col.module--ColPush_6",
  "col_xs_push_6": "Base-Rid-Col.module--ColXsPush_6",
  "col_push_7": "Base-Rid-Col.module--ColPush_7",
  "col_xs_push_7": "Base-Rid-Col.module--ColXsPush_7",
  "col_push_8": "Base-Rid-Col.module--ColPush_8",
  "col_xs_push_8": "Base-Rid-Col.module--ColXsPush_8",
  "col_push_9": "Base-Rid-Col.module--ColPush_9",
  "col_xs_push_9": "Base-Rid-Col.module--ColXsPush_9",
  "col_push_10": "Base-Rid-Col.module--ColPush_10",
  "col_xs_push_10": "Base-Rid-Col.module--ColXsPush_10",
  "col_push_11": "Base-Rid-Col.module--ColPush_11",
  "col_xs_push_11": "Base-Rid-Col.module--ColXsPush_11",
  "col_push_12": "Base-Rid-Col.module--ColPush_12",
  "col_xs_push_12": "Base-Rid-Col.module--ColXsPush_12",
  "col_sm_span_0": "Base-Rid-Col.module--ColSmSpan_0",
  "col_sm_span_1": "Base-Rid-Col.module--ColSmSpan_1",
  "col_sm_span_2": "Base-Rid-Col.module--ColSmSpan_2",
  "col_sm_span_3": "Base-Rid-Col.module--ColSmSpan_3",
  "col_sm_span_4": "Base-Rid-Col.module--ColSmSpan_4",
  "col_sm_span_5": "Base-Rid-Col.module--ColSmSpan_5",
  "col_sm_span_6": "Base-Rid-Col.module--ColSmSpan_6",
  "col_sm_span_7": "Base-Rid-Col.module--ColSmSpan_7",
  "col_sm_span_8": "Base-Rid-Col.module--ColSmSpan_8",
  "col_sm_span_9": "Base-Rid-Col.module--ColSmSpan_9",
  "col_sm_span_10": "Base-Rid-Col.module--ColSmSpan_10",
  "col_sm_span_11": "Base-Rid-Col.module--ColSmSpan_11",
  "col_sm_span_12": "Base-Rid-Col.module--ColSmSpan_12",
  "col_sm_offset_0": "Base-Rid-Col.module--ColSmOffset_0",
  "col_sm_offset_1": "Base-Rid-Col.module--ColSmOffset_1",
  "col_sm_offset_2": "Base-Rid-Col.module--ColSmOffset_2",
  "col_sm_offset_3": "Base-Rid-Col.module--ColSmOffset_3",
  "col_sm_offset_4": "Base-Rid-Col.module--ColSmOffset_4",
  "col_sm_offset_5": "Base-Rid-Col.module--ColSmOffset_5",
  "col_sm_offset_6": "Base-Rid-Col.module--ColSmOffset_6",
  "col_sm_offset_7": "Base-Rid-Col.module--ColSmOffset_7",
  "col_sm_offset_8": "Base-Rid-Col.module--ColSmOffset_8",
  "col_sm_offset_9": "Base-Rid-Col.module--ColSmOffset_9",
  "col_sm_offset_10": "Base-Rid-Col.module--ColSmOffset_10",
  "col_sm_offset_11": "Base-Rid-Col.module--ColSmOffset_11",
  "col_sm_order_0": "Base-Rid-Col.module--ColSmOrder_0",
  "col_sm_order_1": "Base-Rid-Col.module--ColSmOrder_1",
  "col_sm_order_2": "Base-Rid-Col.module--ColSmOrder_2",
  "col_sm_order_3": "Base-Rid-Col.module--ColSmOrder_3",
  "col_sm_order_4": "Base-Rid-Col.module--ColSmOrder_4",
  "col_sm_order_5": "Base-Rid-Col.module--ColSmOrder_5",
  "col_sm_order_6": "Base-Rid-Col.module--ColSmOrder_6",
  "col_sm_order_7": "Base-Rid-Col.module--ColSmOrder_7",
  "col_sm_order_8": "Base-Rid-Col.module--ColSmOrder_8",
  "col_sm_order_9": "Base-Rid-Col.module--ColSmOrder_9",
  "col_sm_order_10": "Base-Rid-Col.module--ColSmOrder_10",
  "col_sm_order_11": "Base-Rid-Col.module--ColSmOrder_11",
  "col_sm_order_12": "Base-Rid-Col.module--ColSmOrder_12",
  "col_sm_pull_0": "Base-Rid-Col.module--ColSmPull_0",
  "col_sm_pull_1": "Base-Rid-Col.module--ColSmPull_1",
  "col_sm_pull_2": "Base-Rid-Col.module--ColSmPull_2",
  "col_sm_pull_3": "Base-Rid-Col.module--ColSmPull_3",
  "col_sm_pull_4": "Base-Rid-Col.module--ColSmPull_4",
  "col_sm_pull_5": "Base-Rid-Col.module--ColSmPull_5",
  "col_sm_pull_6": "Base-Rid-Col.module--ColSmPull_6",
  "col_sm_pull_7": "Base-Rid-Col.module--ColSmPull_7",
  "col_sm_pull_8": "Base-Rid-Col.module--ColSmPull_8",
  "col_sm_pull_9": "Base-Rid-Col.module--ColSmPull_9",
  "col_sm_pull_10": "Base-Rid-Col.module--ColSmPull_10",
  "col_sm_pull_11": "Base-Rid-Col.module--ColSmPull_11",
  "col_sm_pull_12": "Base-Rid-Col.module--ColSmPull_12",
  "col_sm_push_0": "Base-Rid-Col.module--ColSmPush_0",
  "col_sm_push_1": "Base-Rid-Col.module--ColSmPush_1",
  "col_sm_push_2": "Base-Rid-Col.module--ColSmPush_2",
  "col_sm_push_3": "Base-Rid-Col.module--ColSmPush_3",
  "col_sm_push_4": "Base-Rid-Col.module--ColSmPush_4",
  "col_sm_push_5": "Base-Rid-Col.module--ColSmPush_5",
  "col_sm_push_6": "Base-Rid-Col.module--ColSmPush_6",
  "col_sm_push_7": "Base-Rid-Col.module--ColSmPush_7",
  "col_sm_push_8": "Base-Rid-Col.module--ColSmPush_8",
  "col_sm_push_9": "Base-Rid-Col.module--ColSmPush_9",
  "col_sm_push_10": "Base-Rid-Col.module--ColSmPush_10",
  "col_sm_push_11": "Base-Rid-Col.module--ColSmPush_11",
  "col_sm_push_12": "Base-Rid-Col.module--ColSmPush_12",
  "col_md_span_0": "Base-Rid-Col.module--ColMdSpan_0",
  "col_md_span_1": "Base-Rid-Col.module--ColMdSpan_1",
  "col_md_span_2": "Base-Rid-Col.module--ColMdSpan_2",
  "col_md_span_3": "Base-Rid-Col.module--ColMdSpan_3",
  "col_md_span_4": "Base-Rid-Col.module--ColMdSpan_4",
  "col_md_span_5": "Base-Rid-Col.module--ColMdSpan_5",
  "col_md_span_6": "Base-Rid-Col.module--ColMdSpan_6",
  "col_md_span_7": "Base-Rid-Col.module--ColMdSpan_7",
  "col_md_span_8": "Base-Rid-Col.module--ColMdSpan_8",
  "col_md_span_9": "Base-Rid-Col.module--ColMdSpan_9",
  "col_md_span_10": "Base-Rid-Col.module--ColMdSpan_10",
  "col_md_span_11": "Base-Rid-Col.module--ColMdSpan_11",
  "col_md_span_12": "Base-Rid-Col.module--ColMdSpan_12",
  "col_md_offset_0": "Base-Rid-Col.module--ColMdOffset_0",
  "col_md_offset_1": "Base-Rid-Col.module--ColMdOffset_1",
  "col_md_offset_2": "Base-Rid-Col.module--ColMdOffset_2",
  "col_md_offset_3": "Base-Rid-Col.module--ColMdOffset_3",
  "col_md_offset_4": "Base-Rid-Col.module--ColMdOffset_4",
  "col_md_offset_5": "Base-Rid-Col.module--ColMdOffset_5",
  "col_md_offset_6": "Base-Rid-Col.module--ColMdOffset_6",
  "col_md_offset_7": "Base-Rid-Col.module--ColMdOffset_7",
  "col_md_offset_8": "Base-Rid-Col.module--ColMdOffset_8",
  "col_md_offset_9": "Base-Rid-Col.module--ColMdOffset_9",
  "col_md_offset_10": "Base-Rid-Col.module--ColMdOffset_10",
  "col_md_offset_11": "Base-Rid-Col.module--ColMdOffset_11",
  "col_md_order_0": "Base-Rid-Col.module--ColMdOrder_0",
  "col_md_order_1": "Base-Rid-Col.module--ColMdOrder_1",
  "col_md_order_2": "Base-Rid-Col.module--ColMdOrder_2",
  "col_md_order_3": "Base-Rid-Col.module--ColMdOrder_3",
  "col_md_order_4": "Base-Rid-Col.module--ColMdOrder_4",
  "col_md_order_5": "Base-Rid-Col.module--ColMdOrder_5",
  "col_md_order_6": "Base-Rid-Col.module--ColMdOrder_6",
  "col_md_order_7": "Base-Rid-Col.module--ColMdOrder_7",
  "col_md_order_8": "Base-Rid-Col.module--ColMdOrder_8",
  "col_md_order_9": "Base-Rid-Col.module--ColMdOrder_9",
  "col_md_order_10": "Base-Rid-Col.module--ColMdOrder_10",
  "col_md_order_11": "Base-Rid-Col.module--ColMdOrder_11",
  "col_md_order_12": "Base-Rid-Col.module--ColMdOrder_12",
  "col_md_pull_0": "Base-Rid-Col.module--ColMdPull_0",
  "col_md_pull_1": "Base-Rid-Col.module--ColMdPull_1",
  "col_md_pull_2": "Base-Rid-Col.module--ColMdPull_2",
  "col_md_pull_3": "Base-Rid-Col.module--ColMdPull_3",
  "col_md_pull_4": "Base-Rid-Col.module--ColMdPull_4",
  "col_md_pull_5": "Base-Rid-Col.module--ColMdPull_5",
  "col_md_pull_6": "Base-Rid-Col.module--ColMdPull_6",
  "col_md_pull_7": "Base-Rid-Col.module--ColMdPull_7",
  "col_md_pull_8": "Base-Rid-Col.module--ColMdPull_8",
  "col_md_pull_9": "Base-Rid-Col.module--ColMdPull_9",
  "col_md_pull_10": "Base-Rid-Col.module--ColMdPull_10",
  "col_md_pull_11": "Base-Rid-Col.module--ColMdPull_11",
  "col_md_pull_12": "Base-Rid-Col.module--ColMdPull_12",
  "col_md_push_0": "Base-Rid-Col.module--ColMdPush_0",
  "col_md_push_1": "Base-Rid-Col.module--ColMdPush_1",
  "col_md_push_2": "Base-Rid-Col.module--ColMdPush_2",
  "col_md_push_3": "Base-Rid-Col.module--ColMdPush_3",
  "col_md_push_4": "Base-Rid-Col.module--ColMdPush_4",
  "col_md_push_5": "Base-Rid-Col.module--ColMdPush_5",
  "col_md_push_6": "Base-Rid-Col.module--ColMdPush_6",
  "col_md_push_7": "Base-Rid-Col.module--ColMdPush_7",
  "col_md_push_8": "Base-Rid-Col.module--ColMdPush_8",
  "col_md_push_9": "Base-Rid-Col.module--ColMdPush_9",
  "col_md_push_10": "Base-Rid-Col.module--ColMdPush_10",
  "col_md_push_11": "Base-Rid-Col.module--ColMdPush_11",
  "col_md_push_12": "Base-Rid-Col.module--ColMdPush_12",
  "col_lg_span_0": "Base-Rid-Col.module--ColLgSpan_0",
  "col_lg_span_1": "Base-Rid-Col.module--ColLgSpan_1",
  "col_lg_span_2": "Base-Rid-Col.module--ColLgSpan_2",
  "col_lg_span_3": "Base-Rid-Col.module--ColLgSpan_3",
  "col_lg_span_4": "Base-Rid-Col.module--ColLgSpan_4",
  "col_lg_span_5": "Base-Rid-Col.module--ColLgSpan_5",
  "col_lg_span_6": "Base-Rid-Col.module--ColLgSpan_6",
  "col_lg_span_7": "Base-Rid-Col.module--ColLgSpan_7",
  "col_lg_span_8": "Base-Rid-Col.module--ColLgSpan_8",
  "col_lg_span_9": "Base-Rid-Col.module--ColLgSpan_9",
  "col_lg_span_10": "Base-Rid-Col.module--ColLgSpan_10",
  "col_lg_span_11": "Base-Rid-Col.module--ColLgSpan_11",
  "col_lg_span_12": "Base-Rid-Col.module--ColLgSpan_12",
  "col_lg_offset_0": "Base-Rid-Col.module--ColLgOffset_0",
  "col_lg_offset_1": "Base-Rid-Col.module--ColLgOffset_1",
  "col_lg_offset_2": "Base-Rid-Col.module--ColLgOffset_2",
  "col_lg_offset_3": "Base-Rid-Col.module--ColLgOffset_3",
  "col_lg_offset_4": "Base-Rid-Col.module--ColLgOffset_4",
  "col_lg_offset_5": "Base-Rid-Col.module--ColLgOffset_5",
  "col_lg_offset_6": "Base-Rid-Col.module--ColLgOffset_6",
  "col_lg_offset_7": "Base-Rid-Col.module--ColLgOffset_7",
  "col_lg_offset_8": "Base-Rid-Col.module--ColLgOffset_8",
  "col_lg_offset_9": "Base-Rid-Col.module--ColLgOffset_9",
  "col_lg_offset_10": "Base-Rid-Col.module--ColLgOffset_10",
  "col_lg_offset_11": "Base-Rid-Col.module--ColLgOffset_11",
  "col_lg_order_0": "Base-Rid-Col.module--ColLgOrder_0",
  "col_lg_order_1": "Base-Rid-Col.module--ColLgOrder_1",
  "col_lg_order_2": "Base-Rid-Col.module--ColLgOrder_2",
  "col_lg_order_3": "Base-Rid-Col.module--ColLgOrder_3",
  "col_lg_order_4": "Base-Rid-Col.module--ColLgOrder_4",
  "col_lg_order_5": "Base-Rid-Col.module--ColLgOrder_5",
  "col_lg_order_6": "Base-Rid-Col.module--ColLgOrder_6",
  "col_lg_order_7": "Base-Rid-Col.module--ColLgOrder_7",
  "col_lg_order_8": "Base-Rid-Col.module--ColLgOrder_8",
  "col_lg_order_9": "Base-Rid-Col.module--ColLgOrder_9",
  "col_lg_order_10": "Base-Rid-Col.module--ColLgOrder_10",
  "col_lg_order_11": "Base-Rid-Col.module--ColLgOrder_11",
  "col_lg_order_12": "Base-Rid-Col.module--ColLgOrder_12",
  "col_lg_pull_0": "Base-Rid-Col.module--ColLgPull_0",
  "col_lg_pull_1": "Base-Rid-Col.module--ColLgPull_1",
  "col_lg_pull_2": "Base-Rid-Col.module--ColLgPull_2",
  "col_lg_pull_3": "Base-Rid-Col.module--ColLgPull_3",
  "col_lg_pull_4": "Base-Rid-Col.module--ColLgPull_4",
  "col_lg_pull_5": "Base-Rid-Col.module--ColLgPull_5",
  "col_lg_pull_6": "Base-Rid-Col.module--ColLgPull_6",
  "col_lg_pull_7": "Base-Rid-Col.module--ColLgPull_7",
  "col_lg_pull_8": "Base-Rid-Col.module--ColLgPull_8",
  "col_lg_pull_9": "Base-Rid-Col.module--ColLgPull_9",
  "col_lg_pull_10": "Base-Rid-Col.module--ColLgPull_10",
  "col_lg_pull_11": "Base-Rid-Col.module--ColLgPull_11",
  "col_lg_pull_12": "Base-Rid-Col.module--ColLgPull_12",
  "col_lg_push_0": "Base-Rid-Col.module--ColLgPush_0",
  "col_lg_push_1": "Base-Rid-Col.module--ColLgPush_1",
  "col_lg_push_2": "Base-Rid-Col.module--ColLgPush_2",
  "col_lg_push_3": "Base-Rid-Col.module--ColLgPush_3",
  "col_lg_push_4": "Base-Rid-Col.module--ColLgPush_4",
  "col_lg_push_5": "Base-Rid-Col.module--ColLgPush_5",
  "col_lg_push_6": "Base-Rid-Col.module--ColLgPush_6",
  "col_lg_push_7": "Base-Rid-Col.module--ColLgPush_7",
  "col_lg_push_8": "Base-Rid-Col.module--ColLgPush_8",
  "col_lg_push_9": "Base-Rid-Col.module--ColLgPush_9",
  "col_lg_push_10": "Base-Rid-Col.module--ColLgPush_10",
  "col_lg_push_11": "Base-Rid-Col.module--ColLgPush_11",
  "col_lg_push_12": "Base-Rid-Col.module--ColLgPush_12",
  "col_xl_span_0": "Base-Rid-Col.module--ColXlSpan_0",
  "col_xl_span_1": "Base-Rid-Col.module--ColXlSpan_1",
  "col_xl_span_2": "Base-Rid-Col.module--ColXlSpan_2",
  "col_xl_span_3": "Base-Rid-Col.module--ColXlSpan_3",
  "col_xl_span_4": "Base-Rid-Col.module--ColXlSpan_4",
  "col_xl_span_5": "Base-Rid-Col.module--ColXlSpan_5",
  "col_xl_span_6": "Base-Rid-Col.module--ColXlSpan_6",
  "col_xl_span_7": "Base-Rid-Col.module--ColXlSpan_7",
  "col_xl_span_8": "Base-Rid-Col.module--ColXlSpan_8",
  "col_xl_span_9": "Base-Rid-Col.module--ColXlSpan_9",
  "col_xl_span_10": "Base-Rid-Col.module--ColXlSpan_10",
  "col_xl_span_11": "Base-Rid-Col.module--ColXlSpan_11",
  "col_xl_span_12": "Base-Rid-Col.module--ColXlSpan_12",
  "col_xl_offset_0": "Base-Rid-Col.module--ColXlOffset_0",
  "col_xl_offset_1": "Base-Rid-Col.module--ColXlOffset_1",
  "col_xl_offset_2": "Base-Rid-Col.module--ColXlOffset_2",
  "col_xl_offset_3": "Base-Rid-Col.module--ColXlOffset_3",
  "col_xl_offset_4": "Base-Rid-Col.module--ColXlOffset_4",
  "col_xl_offset_5": "Base-Rid-Col.module--ColXlOffset_5",
  "col_xl_offset_6": "Base-Rid-Col.module--ColXlOffset_6",
  "col_xl_offset_7": "Base-Rid-Col.module--ColXlOffset_7",
  "col_xl_offset_8": "Base-Rid-Col.module--ColXlOffset_8",
  "col_xl_offset_9": "Base-Rid-Col.module--ColXlOffset_9",
  "col_xl_offset_10": "Base-Rid-Col.module--ColXlOffset_10",
  "col_xl_offset_11": "Base-Rid-Col.module--ColXlOffset_11",
  "col_xl_order_0": "Base-Rid-Col.module--ColXlOrder_0",
  "col_xl_order_1": "Base-Rid-Col.module--ColXlOrder_1",
  "col_xl_order_2": "Base-Rid-Col.module--ColXlOrder_2",
  "col_xl_order_3": "Base-Rid-Col.module--ColXlOrder_3",
  "col_xl_order_4": "Base-Rid-Col.module--ColXlOrder_4",
  "col_xl_order_5": "Base-Rid-Col.module--ColXlOrder_5",
  "col_xl_order_6": "Base-Rid-Col.module--ColXlOrder_6",
  "col_xl_order_7": "Base-Rid-Col.module--ColXlOrder_7",
  "col_xl_order_8": "Base-Rid-Col.module--ColXlOrder_8",
  "col_xl_order_9": "Base-Rid-Col.module--ColXlOrder_9",
  "col_xl_order_10": "Base-Rid-Col.module--ColXlOrder_10",
  "col_xl_order_11": "Base-Rid-Col.module--ColXlOrder_11",
  "col_xl_order_12": "Base-Rid-Col.module--ColXlOrder_12",
  "col_xl_pull_0": "Base-Rid-Col.module--ColXlPull_0",
  "col_xl_pull_1": "Base-Rid-Col.module--ColXlPull_1",
  "col_xl_pull_2": "Base-Rid-Col.module--ColXlPull_2",
  "col_xl_pull_3": "Base-Rid-Col.module--ColXlPull_3",
  "col_xl_pull_4": "Base-Rid-Col.module--ColXlPull_4",
  "col_xl_pull_5": "Base-Rid-Col.module--ColXlPull_5",
  "col_xl_pull_6": "Base-Rid-Col.module--ColXlPull_6",
  "col_xl_pull_7": "Base-Rid-Col.module--ColXlPull_7",
  "col_xl_pull_8": "Base-Rid-Col.module--ColXlPull_8",
  "col_xl_pull_9": "Base-Rid-Col.module--ColXlPull_9",
  "col_xl_pull_10": "Base-Rid-Col.module--ColXlPull_10",
  "col_xl_pull_11": "Base-Rid-Col.module--ColXlPull_11",
  "col_xl_pull_12": "Base-Rid-Col.module--ColXlPull_12",
  "col_xl_push_0": "Base-Rid-Col.module--ColXlPush_0",
  "col_xl_push_1": "Base-Rid-Col.module--ColXlPush_1",
  "col_xl_push_2": "Base-Rid-Col.module--ColXlPush_2",
  "col_xl_push_3": "Base-Rid-Col.module--ColXlPush_3",
  "col_xl_push_4": "Base-Rid-Col.module--ColXlPush_4",
  "col_xl_push_5": "Base-Rid-Col.module--ColXlPush_5",
  "col_xl_push_6": "Base-Rid-Col.module--ColXlPush_6",
  "col_xl_push_7": "Base-Rid-Col.module--ColXlPush_7",
  "col_xl_push_8": "Base-Rid-Col.module--ColXlPush_8",
  "col_xl_push_9": "Base-Rid-Col.module--ColXlPush_9",
  "col_xl_push_10": "Base-Rid-Col.module--ColXlPush_10",
  "col_xl_push_11": "Base-Rid-Col.module--ColXlPush_11",
  "col_xl_push_12": "Base-Rid-Col.module--ColXlPush_12"
};

export { defaultStyles as default };
